import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "d-lg-flex align-items-center justify-content-between mb-3" }
const _hoisted_7 = { class: "row g-3 pt-4" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "fw-semibold mb-0" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = { class: "fw-semibold mb-0" }
const _hoisted_12 = { class: "badge bg-primary-subtle text-primary" }
const _hoisted_13 = { class: "col-md-2" }
const _hoisted_14 = { class: "fw-semibold mb-0" }
const _hoisted_15 = { class: "row mt-4" }
const _hoisted_16 = { class: "card shadow-lg border-0 rounded-3 h-100" }
const _hoisted_17 = { class: "card-body d-flex flex-column" }
const _hoisted_18 = { class: "card-title fw-bold text-primary" }
const _hoisted_19 = { class: "text-muted fw-bold small mb-3" }
const _hoisted_20 = { class: "text-muted small mb-3" }
const _hoisted_21 = { class: "text-muted small mb-3" }
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-0" }, "Informations générales", -1)),
              _createVNode(_component_router_link, {
                to: "/liste-manifestes",
                class: "btn btn-primary transition border-0 lh-1 fw-medium"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                  _createTextVNode(" Retour ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Code de l'émetteur", -1)),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.manifest?.carrierCode), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Référence Sic", -1)),
                _createElementVNode("p", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.manifest?.manifestReference), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Manifeste Date", -1)),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.format_Date(_ctx.manifest?.manifestDate)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manifestBls, (mani, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("h5", _hoisted_18, _toDisplayString(mani.carrierBlNumber), 1),
                    _createElementVNode("p", _hoisted_19, " Destinataire : " + _toDisplayString(mani.consigneeName), 1),
                    _createElementVNode("p", _hoisted_20, " NbrMarchandises : " + _toDisplayString(mani.cargoItems.length), 1),
                    _createElementVNode("p", _hoisted_21, " NbrConteneurs : " + _toDisplayString(mani.containers.length), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-outline-primary mt-auto",
                      onClick: ($event: any) => (_ctx.$router.push({ name: 'ViewEquipMarchandPage', params: { id: mani.id } }))
                    }, " Voir les détails ", 8, _hoisted_22)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}